import React from 'react';
import {Outlet, useParams, useSearchParams} from "react-router-dom";

import Page from "../../layouts/Main/Page";

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tableau from "./Tableau";
import {LoadingOverlay} from "../../components/LoadingOverlay";
import useAccommodations from "../../components/Accommodations/useAccommodations";
import {useBookingsQuery} from "./query";
import Arrivals from "./Arrivals";
import Availabilities from "./Availabilities";

const tabs = ['tableau', 'arrivals', 'availabilities'];

const BookingsPage = ({accommodations, bookings}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedTab = tabs.find(tab => tab === searchParams.get("tab")) || "tableau";

    const params = useParams();
    const bookingId = params.bookingId;

    return (
        <>
            <Page title="Prenotazioni"
                  disablePadding
                  hidden={bookingId !== null && bookingId !== undefined}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs variant="scrollable"
                          aria-label="booking tabs"
                          value={selectedTab}
                          onChange={(e, newValue) => setSearchParams({tab: newValue})}>
                        <Tab label="Tableau" value="tableau"/>
                        <Tab label="Arrivi" value="arrivals"/>
                        <Tab label="Disponibilità" value="availabilities"/>
                    </Tabs>
                </Box>
                { selectedTab === "tableau" && <Tableau accommodations={accommodations} bookings={bookings}/> }
                { selectedTab === "arrivals" && <Arrivals accommodations={accommodations} bookings={bookings}/>}
                { selectedTab === "availabilities" && <Availabilities accommodations={accommodations}/> }
            </Page>

            {
                <Outlet/>
            }
        </>
    )
}

const Bookings = () => {
    const accommodations = useAccommodations();
    const bookingsQuery = useBookingsQuery();

    return <LoadingOverlay isLoading={accommodations.isLoading || bookingsQuery.isLoading } size='large'>
        <BookingsPage accommodations={accommodations} bookings={bookingsQuery.data}/>
    </LoadingOverlay>
};

export default Bookings;